module.exports = __webpack_public_path__ + "static/media/megaphone-g.8dacdbe6.svg";